import { BrandMark } from './BrandMark'

interface BrandLockupProps {
  className?: string
  descriptor?: string
  glow?: boolean
  markOnly?: boolean
  size?: 'sm' | 'md' | 'lg'
}

const SIZE_STYLES = {
  sm: {
    mark: 'h-6 w-6',
    wordmark: 'text-sm',
    descriptor: 'text-[8px]',
  },
  md: {
    mark: 'h-8 w-8',
    wordmark: 'text-base',
    descriptor: 'text-[9px]',
  },
  lg: {
    mark: 'h-11 w-11',
    wordmark: 'text-xl',
    descriptor: 'text-[10px]',
  },
} as const

/**
 * Canonical BeetleSense lockup.
 *
 * The supplied beetle-and-stars mark is the only brand symbol. Product names
 * are descriptors beneath the BeetleSense wordmark, never replacement logos.
 */
export function BrandLockup({
  className = '',
  descriptor,
  glow = false,
  markOnly = false,
  size = 'md',
}: BrandLockupProps) {
  const styles = SIZE_STYLES[size]

  return (
    <span className={`brand-lockup ${className}`}>
      <BrandMark
        className={`${styles.mark} shrink-0 text-[var(--brand-signal,var(--green))]`}
        glow={glow}
      />
      {!markOnly && (
        <span className="min-w-0 leading-none">
          <span className={`brand-wordmark block ${styles.wordmark}`}>BeetleSense</span>
          {descriptor && (
            <span className={`brand-descriptor mt-1 block truncate ${styles.descriptor}`}>
              {descriptor}
            </span>
          )}
        </span>
      )}
    </span>
  )
}
